<template>
<div v-show="show" :style="{ 'z-index': (currentZIndex-1)}">
    <div :style="{ 'z-index': (currentZIndex)}"
      class="dimmed_black" style="top:0;display:block;"></div>
    <!--popup 시작-->
    <div :style="{ 'z-index': (currentZIndex+1)}"
     class="rew19_popContainer big" id="pop_stortage" style="display: block">
        <div class="rew19_popup_wrap">
            <h2>
                <span class="rew19_basketList_tit">주문제품 재고부족에 따른 안내</span>
                <button class="rew19_basketList_btn" @click="onCancel"><span>닫기</span></button>
            </h2>
        </div>
        <div class="rew19_popup_cont">
            <div class="rew19_order_box">
                <p>회원님께서 주문하신 커스텀 프로덕트 세트 중 현재
                <em class="rew19_point">재고가 부족</em>한 제품이 있습니다. </p>
                <span class="rew18_text_temp">{{agelocTempMsg}}</span>
                <span>아래의 주문 목록에서 주문 방법을 선택해 주세요.</span>
            </div>
            <div class="rew19_trenches">
                <p class="rew19_order_txt">재고부족으로 인하여 다른 스킨 케어 코드를 추천받기 원하시는 경우, 해당 제품을 삭제하고 콜센터 (1588-1440)로 문의해 주시기 바랍니다.</p>
            </div>

            <dl class="rew19_select_table order rew19_trenches">
                <dt>
                <span class="rew19_table_tit">주문 방법 선택</span>
                </dt>
                <div>
                <dd v-for="(item, idx) in viewData.skincareStock"
                    v-bind:key="idx">
                <ul class="rew19_table_form skinCare">
                    <li class="o2">
                        <em class="rew19_tit">{{item.agm_code}}</em>
                        <span class="rew19_point">{{item.stockStatusName}} <a @click="deleteSkinCareCode(item)" :class="{ disabled : item.showDeleteIcon}" class="del">삭제</a></span>
                        <span class="rew19_people">{{item.agm_name}}</span>
                        <p>{{item.agm_detail}}</p>

                        <ul v-if="item.status =='610' || item.backOrdered == true" class="rew19_radio_sequence rew19_clear">
                            <li v-if="item.backOrdered == true">
                                <input type="radio"
                                    :name="'skincareProduct_'+idx"
                                    class="rew19_fakeRadio_t1" v-model="item.skincareProduct" value="WAIT" :id="'skincareProduct_'+idx+'wait'">
                                <label :for="'skincareProduct_'+idx+'wait'">
                                배송 대기
                                </label>
                            </li>
                            <li>
                                <input type="radio"
                                    :name="'skincareProduct_'+idx"
                                    class="rew19_fakeRadio_t1" v-model="item.skincareProduct" value="DEFAULT" :id="'skincareProduct_'+idx+'default'">
                                <label :for="'skincareProduct_'+idx+'default'">
                                베이직 스킨케어 세트 주문
                                </label>
                            </li>
                            <li>
                                <input type="radio"
                                    :name="'skincareProduct_'+idx"
                                    class="rew19_fakeRadio_t1" v-model="item.skincareProduct" value="DELETE" :id="'skincareProduct_'+idx+'delete'">
                                <label :for="'skincareProduct_'+idx+'delete'">
                                제품 삭제
                                </label>
                            </li>
                        </ul>
                    </li>
                </ul>
                </dd>
                </div>
            </dl>

            <h3 class="rew19_order_tit">주문 방법에 대한 상세 안내</h3>
            <dl class="rew19_order_guide">
                <dt class="o1">배송대기</dt>
                <dd>선 결제 후, 제품의 재고가 준비되는 대로 장바구니 내 모든 제품을 함께 배송합니다.
                    즉시 배송 가능한 제품만 주문하시려면, 따로 따로 주문해 주세요.</dd>
                <dt class="o2">베이직 스킨케어 세트 주문 </dt>
                <dd>재고가 부족한 제품을 베이직 스킨케어 제품으로 교환하여 구매합니다</dd>
                <dt class="o3">제품 삭제</dt>
                <dd>재고가 부족한 제품을 주문 목록에서 삭제합니다.</dd>
            </dl>

        </div><!--//rew19_popup_cont-->
        <div class="rew19_popup_btn rew19_clear">
            <button class="rew19_popHarf disabled" @click="onCancel">취소</button>
            <button class="rew19_popHarf activation" @click="onOk">주문하기</button>
        </div>
    </div>
  </div>
  <!--//popup 끝-->
</template>
<script>
import AroBase from '@/components/base/AroBase';
export default {
    name: "SkinCareStockDialog",
    extends: AroBase,
    props: {
    show: {
      type: Boolean,
      default: false
        }
    },
    data() {
        return{
            currentZIndex : 2000,

            viewData: {
                skincareStock: [
                    {
                       skincareProduct: "DEFAULT",
                       hideDeleteIcon: false,
                    }
                ]
            },
          agelocTempMsg : "",
        }
    },
    watch: {
        show(show) {
            this.$modalAfterTreat(show);

            show && this.$nextTick(() => {
                let _this = this;
                _this.currentZIndex = _this.$getDimmMaxIndex() + 2;

                this.$el.focus();
            })
        }
    },
    updated: function () {
        this.$nextTick(function () {
            $(".rew19_popContainer.big .rew19_popup_cont").css('height', $(window).height() - 102);
        })
    },
    methods: {
        initData(stockList, customList, agelocTempMsg){
            let _this = this;

            _this.viewData.skincareStock = [];
            let viewList = _this.viewData.skincareStock;
            viewList = [...customList];
            let customItem = {};
            for(var i=0; i<viewList.length; i++){
                stockList.forEach((stockItem)=>{
                    if(stockItem.agelocmeAssessmentCode == viewList[i].agm_code){
                        if(stockItem.status === "610"){
                            customItem = {
                                stockStatusName: "품절",
                                status: stockItem.status,
                                backOrdered: stockItem.backOrdered,
                                skincareProduct: "DEFAULT",
                                showDeleteIcon: false
                                }
                        }else{
                            if(stockItem.backOrdered){
                                customItem = {
                                stockStatusName: "재고부족",
                                status: stockItem.status,
                                backOrdered: stockItem.backOrdered,
                                skincareProduct: "WAIT",
                                showDeleteIcon: false
                                }
                            }else{
                                customItem = {
                                stockStatusName: "재고있음",
                                status: stockItem.status,
                                backOrdered: stockItem.backOrdered,
                                skincareProduct: null,
                                showDeleteIcon: true
                                }
                            }
                        }
                    }
                })
                _this.viewData.skincareStock[i] = {...viewList[i], ...customItem};
                _this.agelocTempMsg = agelocTempMsg;
            }
        },
        deleteSkinCareCode(item){
            let _this = this;
            let list = _this.viewData.skincareStock

            for(let i=0; i<list.length; i++){
                if(list[i] == item){
                    _this.viewData.skincareStock.splice(i, 1);

                    break;
                }
            }
        },
        onOk(){
            let _this = this;

            let list = _this.viewData.skincareStock;
            let skincareList = [];

            for(let i=0; i<list.length; i++){
                if(list[i].skincareProduct == "DELETE"){

                }else if(list[i].skincareProduct == "DEFAULT"){
                    list[i].agm_code = "M6FG8P"
                    list[i].agm_name = _this.getMemberNmKr();
                    list[i].agm_detail = "베이직 스킨케어 세트";

                    skincareList.push(list[i]);
                }else{
                    skincareList.push(list[i]);
                }
            }

            _this.$emit('close', true, skincareList);
        },
        onCancel(){
        let _this = this;

        _this.$emit('close', false, null);
        }
    }
}
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/popup/SkinCareStockDialog.vue